import { create } from "zustand"
import { devtools } from "zustand/middleware"

export type InvitationState = {
  invitationTotalEmailList: string[]
  invitationErrorEmailList: string[]
}

export type InvitationAction = {
  setInvitationTotalEmailList: (emailList: string[]) => void
  setInvitationErrorEmailList: (emailList: string[]) => void
}

export type InvitationStore = InvitationState & InvitationAction

export const invitationState: InvitationState = {
  invitationTotalEmailList: [],
  invitationErrorEmailList: [],
}

export const createInvitationStore = create<InvitationStore>()(
  devtools(
    (set) => ({
      ...invitationState,
      setInvitationTotalEmailList: (emailList) => {
        set({ invitationTotalEmailList: emailList }, undefined, "setInvitationTotalEmailList")
      },
      setInvitationErrorEmailList: (emailList) => {
        set({ invitationErrorEmailList: emailList }, undefined, "setInvitationErrorEmailList")
      },
    }),
    {
      store: "invitation",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)
